import { deleteObject, ref as storageRef} from "firebase/storage";
import { storage } from "../firebase";


export const getMediaStoragePath=(url)=>{
    const regex = /o\/(.*?)\?/;
    const match = url.match(regex);
    const lastpath =match ? match[1] : null;
    return lastpath.replace(/%2F/g,"/");
};

export const deleteStorageFile=async (filePath)=>{
    const fileRef = storageRef(storage, filePath);
    try {
        await deleteObject(fileRef);
    } catch(error) {
        console.error(`Error deleting file`, error);
    }
};